@if (initValues(); as initValues) {

  <div class="container page-container">

    <evland-breadcrumbs [items]="breadcrumbs()"></evland-breadcrumbs>

    <h1 i18n>Каталог</h1>

    <evland-catalog-filter (filterChange)="onFilterChange($event)"
                           [initValue]="initValues.filter"></evland-catalog-filter>

    <div [id]="CAR_LIST_ID">

      <evland-car-list (sortChange)="onSortChange($event)" [cars]="series()" [isLoading]="isLoading()"
                       [isUpdating]="isUpdating()" [sortOptions]="sortOptions" [total]="total()"
                       [initValue]="initValues.sort"></evland-car-list>

    </div>

    <evland-pagination (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" [total]="total()"
                       [pageSizes]="pageSizes" [isLoading]="isLoading()"
                       [initValue]="initValues.paginator"></evland-pagination>

    @if (!!(historyItems$ | async)?.length) {
      <evland-view-history></evland-view-history>
    }

    <evland-questions-full-width-form></evland-questions-full-width-form>

  </div>

}
